import React, { Fragment, useContext } from 'react';
import "./contact.css";
import Facebook from '../../assets/fb.jpg';
import YouTube from '../../assets/yt.jpg';
import Twitter from '../../assets/tw.jpg';
import Gmail from '../../assets/Gmail1.jpg';
import Instagram from '../../assets/ig.jpg';
import { AuthorizationContext } from '../../context/authorizationContext';

const Contact = () => {

    const { setPath } = useContext(AuthorizationContext);

    setPath(window.location.pathname);
    
    return (
        <Fragment>
            <div id="contact">

                <div class="feedback">
                    <h1>Contact Us</h1>
                    <form class="form" action="/">
                        <input type="text" placeholder="Your Name" />
                        <input type="email" placeholder="Email-id" />
                        <input id="msg" placeholder="Message /Feedback" />
                        <input type="submit" />
                    </form>
                    <section class="social-media">
                        <p>Let's Connect Socially</p>
                        <div>
                            <a href="/">
                                <img src={Facebook} alt="" />
                            </a>
                            <a href="/">
                                <img src={Gmail} alt="" />
                            </a>
                            <a href="/">
                                <img src={Twitter} alt="" />
                            </a>
                            <a href="/">
                                <img src={Instagram} alt="" />
                            </a>
                            <a href="/">
                                <img src={YouTube} alt="" />
                            </a>
                        </div>
                    </section>
                </div>

                <h3>Developer Details</h3>
                <div class="developers">
                    <div class="dev-det">
                        <p>Keyur Vataliya</p>
                        <small>keyurvataliya1511@gmail.com</small>
                    </div>
                    <div class="dev-det">
                        <p>Harshil Chudasama</p>
                        <small>harshil4821@gmail.com</small>
                    </div>
                    <div class="dev-det">
                        <p>Mihir Vaghela</p>
                        <small>mihir@gmail.com</small>
                    </div>
                    <div class="dev-det">
                        <p>Ayush Prajapati</p>
                        <small>ayush@gmail.com</small>
                    </div>
                </div>
            </div>
        </Fragment>
    )
};

export default Contact;